var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('slide-up-down',{staticClass:"uins-result-count",attrs:{"tag":"div","active":_vm.shouldShowResultCount}},[_vm._v(_vm._s(_vm.resultText)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }